<template>
  <div class="list-info-item">
    <div class="label" v-html="label" />
    <div class="content">
      <h2 v-html="title" />
      <div class="body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListInfoItem',
  props: ['label', 'title'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .list-info-item
    border-bottom: 2px solid $green60
    display: flex
    padding: 7rem 0
    &:last-of-type
      border-bottom: none

  .label
    width: 200px
    font-size: 2rem
    font-weight: 700
    text-transform: uppercase
    color: $primary-color

  h2
    margin: 0
    font-size: 20px
    color: $text-color

  .content
    width: calc(100% - 200px);

  .body
    margin-top: 1em
    line-height: 1.35em
    font-family: space-grotesk

  @media only screen and (max-width: 600px)
    .list-info-item
      display: flex
      flex-direction: column

    .label,
    .content
      width: 100%

</style>
